import { render, staticRenderFns } from "./NoResultsFounded.vue?vue&type=template&id=6d4b6a29&scoped=true&"
import script from "./NoResultsFounded.vue?vue&type=script&lang=js&"
export * from "./NoResultsFounded.vue?vue&type=script&lang=js&"
import style0 from "./NoResultsFounded.vue?vue&type=style&index=0&id=6d4b6a29&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4b6a29",
  null
  
)

export default component.exports